import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 039be9b8-08ad-11e4-bf19-842b2b6cfe1b
 * name vector-square
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-square.svg
 * tags
 * - Vector 
 * - Geographic Information System 
 */
export const VectorSquareIcon = createSvgIcon(<><path d="M2,2H8V4H16V2H22V8H20V16H22V22H16V20H8V22H2V16H4V8H2V2M16,8V6H8V8H6V16H8V18H16V16H18V8H16M4,4V6H6V4H4M18,4V6H20V4H18M4,18V20H6V18H4M18,18V20H20V18H18Z" /></>, 'VectorSquareIcon');
export default VectorSquareIcon